module.exports = __webpack_public_path__ + "static/media/mil51item.c948ef88.png";